import axios from "axios";

import fetchEnv from "../../../utils/FetchEnv";

const cmApiUrl = fetchEnv()?.REACT_APP_APIURL;

const notificationApiUrl = fetchEnv()?.REACT_APP_APIURL_CASE;

export const getReadNotification = (data) => {
  return axios.post(`${cmApiUrl}/ravenService/notification/read`, data);
};

export const getUpdateNotification = (data) => {
  return axios.put(`${cmApiUrl}/ravenService/notification/update`, data);
};

export const getNotificationList = (userId, page = 1, size = 10) => {
  return axios.get(
    `${notificationApiUrl}/caseManagement/api/notifications/user/${userId}?pageNo=${page}&pageSize=${size}`
  );
};

export const getUnreadNotificationCount = (userId) => {
  return axios.get(`${notificationApiUrl}/caseManagement/api/notifications/user/${userId}/unread/count`);
};

export const markNotificationAsRead = (notification_id) => {
  return axios.put(`${notificationApiUrl}/caseManagement/api/notifications/${notification_id}/status/read`);
};
